import { IonTextarea } from '@ionic/react';
import classNames from 'classnames';
import { Field } from 'formik';

type IonInputProps = React.ComponentPropsWithoutRef<typeof IonTextarea>;
const DefaultTextarea: React.FC<IonInputProps> = ({ className, ...rest }) => {
    return (
        <Field
            as={IonTextarea}
            fill="outline"
            labelPlacement="stacked"
            helperText=" "
            className={classNames('custom', className)}
            {...rest}
        ></Field>
    );
};

export default DefaultTextarea;
